import { render, staticRenderFns } from "./ReportParticipants.vue?vue&type=template&id=0a04fdd6&"
import script from "./ReportParticipants.vue?vue&type=script&lang=js&"
export * from "./ReportParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports